module.exports = __webpack_public_path__ + "img/Superb_sword_01.7c2a7ac3.png";